import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ChangeDetectionStrategy
} from "@angular/core";
import moment from "moment";
import { Communication } from "src/model/class/general classes/communication";
import { IconInfo, ItemHistory, Subtitle, TextInfo } from "src/components/shared-components/class/general-classes/item-history";
import { Communications_Kind } from "src/model/enum/enumCommunication";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { CommunicationService } from "src/service/communication.service";
import { LoaderService } from "src/service/loader.service";
import { LoggerService } from "src/service/logger.service";
import { TranslationService } from "src/service/translation.service";

@Component({
    selector: "app-communication-list",
    templateUrl: "./communication-list.component.html",
    styleUrls: ["./communication-list.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommunicationListComponent implements OnInit, OnChanges {
  @Input("kind") kind: Communications_Kind = Communications_Kind.Unknown;
  @Input("topRow") topRow: number = 1000;
  @Input("startDate") startDate = moment();
  @Input("endDate") endDate = moment();
  @Input("idUser") idUser: number = -1;

  private _logContext: string = "Communication-list.component";

  public communicationsKind = Communications_Kind;
  public itemHistoryList: Array<ItemHistory> = new Array<ItemHistory>();

  constructor(
    private _communicationService: CommunicationService,
    private _translateService: TranslationService,
    private _loaderController: LoaderService,
    private _loggerService: LoggerService
  ) { }

  // download communications and show the report list //
  ngOnInit() { }

  ngOnChanges() {
    if (this.kind == Communications_Kind.Push) {
      if (this.idUser != undefined && this.idUser > 0) {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          this._logContext,
          "ngOnChanges()",
          "top row: " + this.topRow
        );
        this._communicationService
          .GetCommunication(
            this.kind,
            this.topRow,
            this.startDate.format("DD-MM-YYYY HH:mm:ss"),
            this.endDate.format("DD-MM-YYYY HH:mm:ss"),
            this.idUser > 0 ? this.idUser.toString() : ""
          )
          .then(async (communications: Array<Communication>) => {
            this.createItemHistoryList(communications);
            await this._loaderController.dismissLoaderWaiting();
          });
      }
    }
  }

  private getDateFormatted(date: Date): string {
    return this._translateService.formatDateTime(moment(date));
  }

  /**
   * Returns the icon associated with a certain kind.
   * @param kind 
   */
  private getIconNameByKind(kind: Communications_Kind): string {
    switch (kind) {
      case Communications_Kind.Call:
        return "call";
      case Communications_Kind.SMS:
        return "chatbox-ellipses";
      case Communications_Kind.Mail:
        return "mail";
      case Communications_Kind.Telegram_Msg:
      case Communications_Kind.Telegram_Contact:
      case Communications_Kind.Telegram_Callback:
        return "paper-plane";
      case Communications_Kind.Push:
        return "notifications";
    }
  }

  /**
   * Create the array containing the objects to show in the app view.
   * @param communication array from which to get the data to create the array to use in the app view
   */
  private createItemHistoryList(communication: Array<Communication>): void {
    this.itemHistoryList = [];
    for (let i = 0; i < communication.length; i++) {
      let newItem: ItemHistory = new ItemHistory();
      newItem.IconInfo = new IconInfo();
      newItem.Id = i;
      newItem.IconInfo.Name = this.getIconNameByKind(communication[i].kind);
      newItem.IconInfo.CssClass = "";
      newItem.Title = new TextInfo();
      newItem.Title.Text = communication[i].text1;
      newItem.Title.CssClass = "";
      newItem.Subtitles = [];
      let subtitle: Subtitle = new Subtitle();
      subtitle.TextInfo = new TextInfo();
      subtitle.TextInfo.Text = communication[i].text2;
      subtitle.TextInfo.CssClass = "";
      subtitle.IconInfo = null;
      newItem.Subtitles.push(subtitle);
      subtitle = new Subtitle();
      subtitle.TextInfo = new TextInfo();
      subtitle.TextInfo.Text = this.getDateFormatted(communication[i].timestampStartOperation);
      subtitle.IconInfo = null;
      newItem.Subtitles.push(subtitle);
      this.itemHistoryList.push(newItem);
    }
  }
}
